import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { DataService } from './data.service';

@Injectable({
  providedIn: 'root'
})
export class PopupService {

  popupEmitter = new Subject<{text: string, color: string, isOpen: boolean}>()

  constructor(private dataService: DataService) { }

  openPopup(text, color) {
    this.popupEmitter.next({text, color, isOpen: true})
  }

  closePopup() {
    this.popupEmitter.next({text: '', color: '', isOpen: false})
  }
 success(text) {
    this.popupEmitter.next({text, color:'#40b3a1', isOpen: true})
  }
  error(text) {
    this.popupEmitter.next({text, color: '#EB325B', isOpen: true})
  }
  
}
